import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for large headings (plays on mount).
export const MaskLines = ({ lines, className = "", delay = 0 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Floating device screenshot (image already includes iPhone frame) with parallax + spotlight.
export const PhoneShot = ({ src, alt, testId, className = "", glow = "gold", offset = 44, loading = "lazy", fetchPriority = "auto" }) => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [offset, -offset]);
  const glowColor =
    glow === "gold"
      ? "rgba(39,75,120,0.10)"
      : glow === "dark"
        ? "rgba(0,0,0,0.06)"
        : "rgba(0,0,0,0.06)";
  return (
    <motion.div ref={ref} style={{ y }} className={`relative ${className}`}>
      <div
        className={`absolute left-1/2 top-1/2 -z-10 h-[80%] w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[90px] transition-opacity duration-300 ${loaded ? "opacity-100" : "opacity-0"}`}
        style={{ background: glowColor }}
      />
      <img
        src={src}
        alt={alt}
        data-testid={testId}
        loading={loading}
        fetchPriority={fetchPriority}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className={`relative z-10 w-full select-none drop-shadow-[0_36px_70px_rgba(0,0,0,0.22)] transition-opacity duration-300 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        draggable={false}
      />
    </motion.div>
  );
};
